import type { IconProps } from "types";

export const Info = ({ color = "#141516", width = "18", height = "18", style }: IconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill={"none"} xmlns="http://www.w3.org/2000/svg" style={style}>
      <path
        d="M9.00008 17.3332C4.39758 17.3332 0.666748 13.6023 0.666748 8.99984C0.666748 4.39734 4.39758 0.666504 9.00008 0.666504C13.6026 0.666504 17.3334 4.39734 17.3334 8.99984C17.3334 13.6023 13.6026 17.3332 9.00008 17.3332ZM9.00008 15.6665C10.7682 15.6665 12.4639 14.9641 13.7141 13.7139C14.9644 12.4636 15.6667 10.7679 15.6667 8.99984C15.6667 7.23173 14.9644 5.53604 13.7141 4.28579C12.4639 3.03555 10.7682 2.33317 9.00008 2.33317C7.23197 2.33317 5.53628 3.03555 4.28604 4.28579C3.03579 5.53604 2.33341 7.23173 2.33341 8.99984C2.33341 10.7679 3.03579 12.4636 4.28604 13.7139C5.53628 14.9641 7.23197 15.6665 9.00008 15.6665ZM8.16675 4.83317H9.83342V6.49984H8.16675V4.83317ZM8.16675 8.1665H9.83342V13.1665H8.16675V8.1665Z"
        fill={color}
      />
    </svg>
  );
};
